import { render, staticRenderFns } from "./Xm.vue?vue&type=template&id=6bd495ed&scoped=true&"
import script from "./Xm.vue?vue&type=script&lang=js&"
export * from "./Xm.vue?vue&type=script&lang=js&"
import style0 from "./Xm.vue?vue&type=style&index=0&id=6bd495ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd495ed",
  null
  
)

export default component.exports